import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _13mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"13mp"} ref={ref}/>
});

_13mpIcon.displayName = "_13mpIcon";
